import React from 'react';
import { RANK_EMPHASIS_COLOR, rankLineStyle } from './rankScale';

// A short sample of one line of RankLineChart, for a legend.
// index: the line at this index of rankLineStyle (1.25 px; the 8th line has a dash).
// emphasis: the line in front (blue-600, 3 px). reference: the dashed reference line (slate-500, 1.5 px).
// The sample is 0.5 px thicker than the line in the chart, so that it stays clear at its short length.
type Props = {
	index?: number,
	emphasis?: boolean,
	reference?: boolean,
	size?: 'normal' | 'large',
};

const SIZE: Record<'normal' | 'large', { width: number, height: number }> = {
	normal: { width: 22, height: 8 },
	large: { width: 33, height: 12 },
};

const RankLineSwatch: React.FunctionComponent<Props> = ({ index = 0, emphasis = false, reference = false, size = 'normal' }) => {
	const line = rankLineStyle(index);
	const { width, height } = SIZE[size];
	const stroke = reference ? undefined : (emphasis ? RANK_EMPHASIS_COLOR : line.color);
	const strokeWidth = (reference ? 1.5 : (emphasis ? 3 : 1.25)) + 0.5;
	const dash = reference ? '4 3' : (!emphasis && line.dashed ? '5 4' : undefined);
	return <svg width={width} height={height} viewBox="0 0 22 8" aria-hidden="true" className="shrink-0">
		<line x1="1" y1="4" x2="21" y2="4" stroke={stroke} className={reference ? 'stroke-slate-500' : undefined}
			strokeWidth={strokeWidth} strokeLinecap="round" strokeDasharray={dash} />
	</svg>;
};

export default RankLineSwatch;
